import React from "react";

// Source
import ControllerLocalization from "../controller/Localization";

let isRendered = false;

const viewLoader: React.FC = () => {
    // Variable
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    return (
        <div className="view_loader" data-at_id="view_loader">
            <div className="container">
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
                <p className="text">{controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.loading : ""}</p>
            </div>
        </div>
    );
};

export default viewLoader;
